module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "_idContainer007",
      "role": "doc-chapter"
    }
  }, [_c('h1', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Chapter 4")]), _vm._v(" "), _c('h2', {
    staticClass: "sub"
  }, [_c('i', [_vm._v("Then")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("N")]), _vm._v("atasha had her own Midtown apartment in the heart of everything. She was lucky, she got to live on her own but her parents still paid for it, so she had all of the freedom without the worry of bills and rent.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim often envied Natasha’s situation, and she told her that. They’d been friends since middle school and had few secrets between them, but the distance in their lives was widening the older they got.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tash couldn’t understand what Kim went through, no matter how much she tried. She always had ideas to save her and simple solutions to whatever problem Kim faced, but it was easy to find an out when your feelings weren’t in the mix, and your heart wasn’t being torn by the choices you faced.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was easy to rip a bandage off when you didn’t have to feel the pain of the removal or bleed once it was done.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Now, the pair settled onto the couch as Natasha turned on her Dell and typed in her password. Kim nipped to the bathroom, pulled her blonde curls back in a scrunchie she had in her bag, and went to splash her face with water.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wasn’t that drunk; the act back at the bar was mostly borne out of despair, and more than that, Natasha’s suggestion had sobered her up and got her thinking.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So what are we doing?” she asked, coming back into the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We,” her friend answered as she pulled up a search engine, “are going to find you the perfect escape, Kim Weston. So what are you feeling? Someplace down south, maybe? I hear Miami is fun.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Too humid in summer,” Kim answered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“California?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We go there all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Hawaii then?” Natasha suggested as she turned to her. “You could surf or climb a volcano.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim didn’t share her enthusiasm. “How about someplace I haven’t been? Somewhere new?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“OK, so why don’t we let Google decide?” Natasha suggested with a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Trust me,” her friend assured as the “I Feel Lucky” prompt appeared and Tash duly pressed “enter.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There. What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Italy?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes. On the other side of the world, a whole ocean away from your folks’ reach,” she added with a satisfied smile. She pushed the laptop in Kim’s direction and a flood of stunningly picturesque images filled her vision.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She knew Italy was beautiful. Her family had visited Venice once when she was six or seven and Kim had always wanted to go back. She remembered Gloria being annoyed with her because all she wanted to do was chase around after the pigeons in St. Mark’s Square.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She flicked through the on-screen images of picture-postcard scenery: blue skies, historical sights, twinkling water and impossibly pretty villages, each one more appealing than the last.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The idea of running away to such a place was unbelievably alluring. Not to mention romantic.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Looks incredible...” she muttered, as she continued her search.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Good place to hide away for a while and maybe get your bearings?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, but there’s no way I can go.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why not?” Natasha challenged. “No one has to know and I certainly won’t tell. What’s stopping you?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How am I going to pay for it? If I use the Amex, Mom and Dad will know and they’d be on the next flight to drag me back before I even arrive,” Kim pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or more likely, have someone else do it. Her driver, probably.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Not if you pay with mine.” Natasha grabbed her purse and pulled out the little magic black rectangle.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim took the credit card from her friend and turned it over in her hands. She bit her lip. Could this tiny piece of plastic be the key to her escape? She grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How much can I spend?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Whatever you need,” Natasha answered airily, as a satisfied grin spread across her face. “No one’s going to check. I can cover your flight, hotel—everything. You’ll need some cash for spending, though, or else your parents will be able to track you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Clearly Natasha had been watching too much true crime on TV again, but Kim was thankful. If she did go ahead with this then she couldn’t take the chance that her parents would find out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“OK, but just coach flights, and nowhere expensive, OK? And I’ll pay you back.” She knew the money wouldn’t matter to her friend but it did to Kim.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If this was going to be about finding her own way, then she needed to get her priorities straight from the get-go.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Great! So let’s find you someplace to stay,” Natasha practically sang as she pulled the laptop closer. “Italy’s a big country. Where would you like to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t know. Does it matter? Isn’t the point of an escape to just go and see what happens?” Kim pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Pin the tail on the donkey then,” Natasha laughed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“On the map. Just close your eyes and pick a spot,” she insisted.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim looked at her skeptically. “Seriously?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Just do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim did as she was bid and they both stared at the part of Italy she’d picked, a spot at the shin area of the boot-shaped map.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Amalfi Coast looked and sounded amazing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And the further along the plan progressed, the more hopeful Kim felt. A chance to take some time out, if only for a little while, was something she hadn’t even realized she needed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Either one last summer hurrah before life as she knew it ended, or the opportunity to find out what the alternatives could be. And perhaps, most importantly, a chance to outmaneuver her parents, have some fun and take charge of her life in the most spectacular way.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“All we need now is your flight. You’re supposed to leave for England next month, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes,” Kim confirmed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So find out the date and we book your flight to Italy for the same day, so your parents won’t be suspicious.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Kim had to laugh. “You really think of everything, don’t you? Espionage would suit you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Don’t think I "), _c('i', [_vm._v("haven’t ")]), _vm._v("considered it,” her friend mused. She continued in her best James Bond voice. “Slater. Natasha Slater. Agent Nine-Inch Heels.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Thanks, Tash,” Kim said as her emotions took over. “For this...for everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of course.” Her friend pulled her in for a hug. “You’re my best friend and I want the best for you. Whatever that may be.” She turned back to her computer. “Now, let’s find a place for you to stay,” she continued. “Somewhere fitting for Kim Weston’s Italian Great Escape.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-234256bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter_4.vue
// module id = 90
// module chunks = 0